export default {
    language: "Tiếng Việt",
    StripeSuccess: {
        loading: "Đang xử lý thanh toán của bạn...",
        successMessage: "Đăng ký của bạn đã được kích hoạt thành công!",
        processingError: "Xử lý thanh toán thất bại, vui lòng liên hệ với chúng tôi",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "Email",
            createdAt: "Ngày tạo",
            noRecord: "Không có bản ghi",
            loginTime: "Thời gian đăng nhập",
        },
        orders: {
            title: "Lịch sử đơn hàng",
            loading: "Đang tải...",
            refresh: "Làm mới",
            orderAmount: "Số tiền",
            points: "Điểm",
            createdAt: "Ngày tạo",
            orderType: "Loại",
            status: "Trạng thái",
            noOrders: "Không có đơn hàng",
            goToSubscription: "Mua điểm",
            freeCredit: "Tín dụng miễn phí",
            paidCredit: "Tín dụng đã thanh toán",
            queryOrderFailed: "Không thể truy vấn đơn hàng",
            statusPaid: "Đã thanh toán",
            statusPending: "Đang chờ xử lý",
            statusCancelled: "Đã hủy",
            statusDeactivated: "Đã vô hiệu hóa",
            checkoutUrlNotAvailable: "Không thể lấy URL thanh toán",
            verifyingPayment: "Đang xác minh trạng thái thanh toán...",
            paymentSuccess: "Thanh toán thành công",
            paymentPending: "Đơn hàng đang chờ thanh toán, vui lòng hoàn tất thanh toán",
            paymentFailed: "Thanh toán thất bại hoặc đã bị hủy",
            paymentStatus: "Trạng thái thanh toán",
            paymentStatusDescription: "Bạn đã hoàn tất thanh toán chưa?",
            cancelPayment: "Hủy thanh toán",
            completedPayment: "Đã hoàn tất thanh toán",
            warning: "Cảnh báo",
            confirmCancelOrder: "Bạn có chắc chắn muốn hủy đơn hàng này không? Hành động này không thể hoàn tác.",
            cancel: "Hủy",
            confirm: "Xác nhận",
            cancellingOrder: "Đang hủy đơn hàng...",
            orderCancelledSuccess: "Đã hủy đơn hàng",
            cancelOrderFailed: "Không thể hủy đơn hàng",
            checkOrderStatusFailed: "Không thể kiểm tra trạng thái đơn hàng",
            promptClick: "Nhấp vào trạng thái \"Đang chờ xử lý\" để tiếp tục thanh toán",
        }
    },
    UserFeedback: {
        title: "Đánh giá của người dùng",
        feedback: "Lắng nghe đánh giá thực tế từ những nhà sáng tạo và chuyên gia trên toàn thế giới về công nghệ xử lý hình ảnh AI của chúng tôi.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Ông Lin",
                profession: "Biên tập viên video & Người sáng tạo nội dung",
                rating: 5,
                comment: "Tuyệt vời! ClixMagicAI cực kỳ nhanh! Tải lên video có hình mờ, trong vài phút bạn sẽ có phiên bản không có hình mờ, hoàn toàn không mất chất lượng. Công cụ không thể thiếu để xóa hình mờ!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Bà Su",
                profession: "Chuyên gia mạng xã hội",
                rating: 5,
                comment: "ClixMagicAI đã cứu bộ sưu tập Instagram của tôi! Nhận diện chính xác các hình mờ phức tạp, xử lý viền mượt mà hơn nhiều so với phần mềm khác và kết quả trông tự nhiên hơn."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Ông Chen",
                profession: "Nhà sản xuất nội dung video ngắn",
                rating: 5,
                comment: "Xóa hình mờ với ClixMagicAI cực kỳ thuận tiện. Xử lý tài liệu TikTok trên đường đi làm, khi đến văn phòng là tải xuống phiên bản HD ngay. Hiệu quả tăng gấp đôi! Thật là một công cụ tuyệt vời cho những người làm truyền thông."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Ông Huang",
                profession: "Nhà thiết kế đồ họa & Giám đốc sáng tạo hình ảnh",
                rating: 5,
                comment: "Là một nhà thiết kế, tôi rất hài lòng! Khi xử lý hình ảnh mẫu có logo từ khách hàng, kết cấu nền được khôi phục tự nhiên, không có dấu vết của Photoshop, tiết kiệm rất nhiều thời gian hậu kỳ."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Bà Emily",
                profession: "Người sáng tạo nội dung số tự do",
                rating: 5,
                comment: "Tôi đã tìm thấy kho báu! Giá thành viên rẻ hơn nhiều so với các sản phẩm xóa hình mờ khác trên thị trường, nhưng hiệu quả lại tốt hơn, đặc biệt là khi xử lý hình mờ trong suốt có gradient."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Ông Robertson",
                profession: "Nhà phát triển khóa học đào tạo doanh nghiệp",
                rating: 5,
                comment: "ClixMagicAI rất tiện lợi vì không cần cài đặt! Máy tính công ty của tôi có hạn chế quyền cài đặt phần mềm, giờ tôi có thể xử lý tài liệu khóa học chỉ bằng trình duyệt, bất cứ lúc nào và ở đâu."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Bà Zhou",
                profession: "Nội trợ & Biên tập viên nội dung cộng đồng",
                rating: 5,
                comment: "Giao diện đơn giản đến mức ngay cả bà ngoại cũng có thể sử dụng! Nếu bạn không có thời gian học phần mềm chuyên nghiệp như Photoshop, hãy thử ClixMagicAI. Hoàn hảo cho người mới như tôi. Haha~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Ông Johnson",
                profession: "Chiến lược gia hình ảnh thương mại điện tử",
                rating: 5,
                comment: "ClixMagicAI cực kỳ mạnh mẽ, có thể xóa hình ảnh, video, đối tượng nhỏ, người, văn bản và nhiều thứ khác. Tính năng đầy đủ, tôi khuyên tất cả mọi người nên dùng~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Bà Fang",
                profession: "Nhiếp ảnh gia nghiệp dư & Người chia sẻ nội dung trực tuyến",
                rating: 5,
                comment: "Wow~ Cuối cùng tôi đã tìm thấy công cụ xóa hình mờ không làm giảm chất lượng hình ảnh! Thần kỳ như phép thuật~ Chỉnh sửa ảnh không còn là vấn đề! Khuyên dùng mạnh mẽ!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Ông Williams",
                profession: "Giảng viên giáo dục trực tuyến",
                rating: 5,
                comment: "Tính năng ghi nhớ vị trí hình mờ cực kỳ hữu ích! Khi xử lý video cho loạt bài giảng, tôi không cần phải chọn lại vùng liên tục, tiết kiệm ít nhất nửa giờ làm việc, tăng đáng kể hiệu quả chuẩn bị bài giảng của tôi."
            }
        ]
    },
    Order: {
        purchasePoints: "Mua điểm",
        subtitle: "Chọn gói điểm phù hợp để sử dụng dịch vụ xóa hình mờ chất lượng cao",
        loginReminderDesc: "Đăng nhập để chọn và mua điểm",
        freeTag: "Miễn phí",
        freePlan: "Gói miễn phí",
        autoActivated: "Tự động kích hoạt sau khi đăng nhập",
        points: "Điểm",
        autoIncluded: "Quà tặng miễn phí",
        discount: "Giảm giá",
        purchase: "Mua ngay",
        paymentStatusDescription: "Bạn đã hoàn tất thanh toán chưa?",
        paymentNotCompleted: "Thanh toán chưa hoàn tất",
        queryOrderFailed: "Kiểm tra trạng thái đơn hàng thất bại",
        cancelPayment: "Hủy thanh toán",
        completedPayment: "Thanh toán hoàn tất",
        warning: "Cảnh báo",
        confirmCancelOrder: "Bạn có chắc muốn hủy đơn hàng này? Hành động này không thể hoàn tác.",
        cancel: "Hủy",
        confirm: "Xác nhận",
        selectProductFirst: "Vui lòng chọn gói trước",
        creatingOrder: "Đang tạo đơn hàng...",
        orderCreated: "Đã tạo đơn hàng thành công",
        createOrderFailed: "Tạo đơn hàng thất bại",
        checkoutUrlNotAvailable: "Không thể lấy liên kết thanh toán",
        cancellingOrder: "Đang hủy đơn hàng...",
        orderCancelledSuccess: "Đã hủy đơn hàng",
        cancelOrderFailed: "Hủy đơn hàng thất bại",
        verifyingPayment: "Đang kiểm tra trạng thái thanh toán...",
        paymentSuccess: "Thanh toán thành công",
        paymentPending: "Đơn hàng đang chờ thanh toán, vui lòng hoàn tất thanh toán",
        paymentFailed: "Thanh toán thất bại hoặc đã bị hủy",
        checkOrderStatusFailed: "Kiểm tra trạng thái đơn hàng thất bại",
        quickStart: "Bắt đầu nhanh",
        shortTerm: "Sử dụng ngắn hạn",
        recommended: "Đề xuất",
        bestValue: "Giá trị nhất",
    },
    Login: {
        title: "Đăng nhập",
        subtitle: "Đăng nhập nhanh với tài khoản mạng xã hội",
        memberTip: "Đăng nhập để sử dụng nhiều tính năng hơn",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Đăng nhập với GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Đăng nhập với Google"
            }
        ],
        error: {
            serverError: "Lỗi máy chủ, vui lòng thử lại sau",
            networkError: "Lỗi mạng, vui lòng kiểm tra kết nối"
        }
    },
    OAuthCallback: {
        loading: "Đang xử lý yêu cầu đăng nhập",
        pleaseWait: "Vui lòng đợi, đang xác minh thông tin đăng nhập...",
        error: "Đăng nhập thất bại",
        backToHome: "Quay lại trang chủ",
        success: "Đăng nhập thành công",
        redirecting: "Đang chuyển hướng đến trang chủ..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Giá",
            faq: "Câu hỏi thường gặp",
        },
        login: "Đăng nhập",
        userMenu: {
            account: "Tài khoản",
            logout: "Đăng xuất",
            credit: "Điểm",
            freeCredit: "Miễn phí",
            paidCredit: "Đã mua",
            nextUpdate: "Cập nhật điểm tiếp theo",
            language: "Ngôn ngữ",
            theme: "Giao diện",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Công cụ chuyên nghiệp được hỗ trợ bởi AI để xóa hình mờ khỏi hình ảnh, video và PDF một cách nhanh chóng",
        fileTypes: {
            image: 'Xóa hình mờ ảnh',
            pdf: 'Xóa hình mờ PDF',
            video: 'Xóa hình mờ video'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Dùng thử miễn phí hàng ngày", icon: "fa-gift" },
            { id: "imageTag", text: "Xóa hình mờ ảnh", icon: "fa-image" },
            { id: "videoTag", text: "Xóa hình mờ video", icon: "fa-video" },
            { id: "aiPoweredTag", text: "Công nghệ AI", icon: "fa-robot" },
            { id: "noRegTag", text: "Đăng nhập & Sử dụng", icon: "fa-user-check" },
        ],
        videoPromt: "Sắp ra mắt!",
        videoDesc: "Chúng tôi đang phát triển tính năng xóa hình mờ video để mang đến trải nghiệm tốt hơn."
    },
    ProductAdv: {
        title: "Khám phá tính năng mạnh mẽ của ClixMagicAI:",
        advs: [
            {
                title: "Công nghệ nhận diện AI: Tự động định vị các phần tử gây nhiễu",
                desc: "Dựa trên thuật toán học sâu, tự động nhận diện hình mờ, văn bản, khuôn mặt và các yếu tố phức tạp trong hình ảnh/video. Hỗ trợ các định dạng từ Instagram, TikTok và các nền tảng khác.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Xóa hình mờ"
            },
            {
                title: "Chuyên gia làm sạch hình ảnh: Xóa logo/dấu thời gian ngay lập tức, không mất chất lượng",
                desc: "Xóa chính xác hình mờ thương hiệu, ngày chụp, sticker và các yếu tố gây nhiễu. AI tự động phục hồi kết cấu nền, làm cho hình ảnh trông tự nhiên như bản gốc.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Xóa hình mờ"
            },
            {
                title: "Công cụ xóa hình mờ động: Loại bỏ văn bản cuộn/logo nền tảng",
                desc: "Xóa một cú nhấp chuột các nút nổi YouTube, hình mờ động TikTok và chữ chạy. AI theo dõi thông minh và xử lý từng khung hình, cho video 4K mượt mà chất lượng cao.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Xóa hình mờ"
            }
        ]
    },
    Footer: {
        social: {
            title: "Liên hệ chúng tôi",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "Điều khoản pháp lý",
        terms: [
            {
                id: 1,
                title: "Chính sách bảo mật",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Điều khoản dịch vụ",
                link: "/terms"
            },
            {
                id: 3,
                title: "Chính sách Cookie",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI Bản quyền đã được bảo hộ."
    },
    Task: {
        image: {
            imageSupportText: 'Hỗ trợ định dạng jpg, jpeg, png, webp, heic, heif, tối đa 10MB mỗi tệp',
            imageFileTooLarge: 'Kích thước tệp vượt quá giới hạn (tối đa 10MB)',
            invalidImageType: 'Định dạng hình ảnh không được hỗ trợ, vui lòng tải lên JPG, JPEG, PNG, WEBP, HEIC hoặc HEIF',
            imageWillCost: 'Sẽ tiêu thụ: 1 điểm',
            hiecSupportText: 'Định dạng HEIC/HEIF sẽ tự động chuyển đổi sang PNG khi gửi',
            hiecSuccess: 'Chuyển đổi định dạng HEIC/HEIF thành công',
            hiecFailed: 'Chuyển đổi định dạng HEIC/HEIF thất bại',
            processingImageTip: 'Đang xử lý hình ảnh của bạn, vui lòng đợi...',
            guide: {
                title: 'Hướng dẫn',
                step1: 'Tải lên hình ảnh',
                step2: 'Tô vùng hình mờ hoặc để mô hình tự động nhận diện',
                step3: 'Nhấp vào gửi'
            }
        },
        common: {
            remaining: 'Điểm còn lại',
            nextUpdate: 'Cập nhật điểm tiếp theo',
            handleError: 'Lỗi khi xử lý tệp, vui lòng thử tệp khác',
            uploadFailed: 'Tải lên tệp thất bại',
            dragText: 'Kéo tệp vào đây hoặc',
            clickText: 'nhấp để tải lên',
            loginRequired: 'Vui lòng đăng nhập trước khi tải lên',
            noRemainingTasks: 'Bạn đã hết điểm',
            loginNow: 'Đăng nhập ngay',
            upgradeNow: 'Mua điểm ngay',
            taskSubmitSuccess: 'Gửi tác vụ thành công',
            taskSubmitError: 'Gửi tác vụ thất bại',
            taskRetrySuccess: 'Thử lại tác vụ thành công!',
            taskRetryError: 'Thử lại tác vụ thất bại!',
            processing: 'Đang xử lý',
            submit: 'Gửi',
            waiting: 'Đang chờ',
            completed: 'Hoàn thành',
            failed: 'Thất bại',
            cancelled: 'Đã hủy',
            url_not_found: 'Không thể lấy liên kết',
            deleted: 'Đã xóa',
            refreshSuccess: 'Đã làm mới danh sách tác vụ',
            refreshFailed: 'Làm mới danh sách tác vụ thất bại',
            deleteSuccess: 'Xóa tác vụ thành công',
            deleteFailed: 'Xóa tác vụ thất bại',
            waitingForCompletion: 'Vui lòng đợi tác vụ hiện tại hoàn thành trước khi thử lại',
            loadOriginalImageFailed: 'Tải hình ảnh gốc thất bại, vui lòng thử lại',
            downloadFailed: 'Tải xuống thất bại',
            startingDownload: 'Bắt đầu tải xuống...',
            noTasks: 'Không có tác vụ',
            refresh: 'Làm mới',
            sort: 'Sắp xếp',
            noFilterTasks: 'Không có tác vụ {filter}',
            compare: 'Xem so sánh',
            originalImage: 'Ảnh gốc',
            processedImage: 'Ảnh đã xử lý',
            dragToCompare: '👈 Kéo để so sánh 👉',
            cancel: "Hủy",
            delete: "Xóa",
            retry: "Thử lại",
            download: "Tải xuống",
            createAt: "Tạo lúc",
            expiredAt: "Hết hạn lúc",
        },
        video: {
            videoSupportText: 'Hỗ trợ định dạng mp4, mov, avi, mkv, tối đa 100MB mỗi tệp',
            videoFileTooLarge: 'Kích thước tệp vượt quá giới hạn (tối đa 100MB)',
            invalidVideoType: 'Định dạng video không được hỗ trợ, vui lòng tải lên MP4, MOV, AVI hoặc MKV',
            videoWillCost: 'Sẽ tiêu thụ: 3 điểm',
            processingVideoTip: 'Đang xử lý video của bạn, vui lòng đợi...',
            guide: {
                step1: 'Tải lên video',
                step2: 'Chọn loại hình mờ và xác định vùng',
                step3: 'Nhấp vào gửi'
            },
            annotationTools: 'Công cụ chú thích',
            selectType: 'Chọn loại',
            deleteAnnotation: 'Xóa chú thích',
            clearAllAnnotations: 'Xóa tất cả',
            annotationHelp: 'Trợ giúp',
            dragTip: 'Kéo để vẽ vùng',
            resizeTip: 'Điều chỉnh kích thước',
            moveTip: 'Có thể di chuyển chú thích',
            processing: 'Đang xử lý',
            submit: 'Gửi',
            taskSubmitSuccess: 'Gửi tác vụ thành công',
            taskSubmitError: 'Gửi tác vụ thất bại',
            retryTaskTip: 'Thử lại thành công',
            retryFailed: 'Thử lại thất bại',
            uploadFailed: 'Tải lên thất bại',
            staticWatermarkDesc: 'Cho hình mờ tĩnh ở vị trí cố định',
            normalWatermarkDesc: 'Cho hình mờ cố định thông thường',
            dynamicWatermarkDesc: 'Cho hình mờ động thay đổi',
            moveWatermarkDesc: 'Cho hình mờ cần di chuyển'
        },
    },
    Router: {
        home: "Trang chủ",
        terms: "Điều khoản dịch vụ",
        privacy: "Chính sách bảo mật",
        cookie: "Chính sách cookie",
        user: "Trung tâm người dùng",
    },
    FAQ: {
        title: "Hướng dẫn sử dụng và Câu hỏi thường gặp ClixMagicAI",
        prompt: "Gặp vấn đề hoặc có thắc mắc? Liên hệ với chúng tôi bất cứ lúc nào: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "ClixMagicAI là gì và hoạt động như thế nào?",
                answer: "ClixMagicAI là công cụ xóa hình mờ tiên tiến được hỗ trợ bởi AI. Nó hỗ trợ nhận diện tự động hình mờ trong hình ảnh và video, đồng thời cung cấp chức năng đánh dấu vị trí hình mờ thủ công. Đối với hình ảnh, hỗ trợ nhiều định dạng chuyển đổi và đảm bảo đầu ra chất lượng cao; đối với video, có thể xử lý hình mờ tĩnh, động và thậm chí hình mờ thay đổi hình dạng."
            },
            {
                id : 2,
                question: "ClixMagicAI có cung cấp dịch vụ miễn phí không?",
                answer: "Có, chúng tôi cung cấp dịch vụ cơ bản miễn phí 3 điểm mỗi ngày! Bạn có thể dùng để xử lý hình ảnh (tiêu thụ 1 điểm mỗi lần) hoặc video (tiêu thụ 3 điểm mỗi lần). Ngoài ra, bạn còn có thể mua thêm điểm, và điểm đã mua có hiệu lực vĩnh viễn."
            },
            {
                id : 3,
                question: "Tôi có thể mua thêm điểm không?",
                answer: "Tất nhiên! Ngoài 3 điểm miễn phí được tặng hàng ngày, bạn còn có thể nhận thêm điểm thông qua các lựa chọn mua của chúng tôi. Tất cả điểm đã mua sẽ có hiệu lực vĩnh viễn, không có ngày hết hạn."
            },
            {
                id : 4,
                question: "Hỗ trợ những định dạng tệp nào?",
                answer: "Đối với hình ảnh, chúng tôi hỗ trợ định dạng PNG, JPEG, JPG, WEBP, HEIC và HEIF, trong đó HEIC và HEIF sẽ tự động chuyển đổi sang PNG. Đối với video, hỗ trợ nhiều định dạng bao gồm MP4 và MOV."
            },
            {
                id : 5,
                question: "Làm thế nào để bảo vệ quyền riêng tư của tôi?",
                answer: "Tại ClixMagicAI, chúng tôi coi trọng quyền riêng tư của người dùng. Tất cả các tệp tải lên sẽ được mã hóa và tự động xóa trong vòng 24 giờ sau khi xử lý xong. Chúng tôi không lưu trữ bất kỳ tệp người dùng hoặc thông tin liên quan nào."
            },
            {
                id : 6,
                question: "Tôi có thể đăng nhập vào ClixMagicAI bằng cách nào?",
                answer: "Chúng tôi hỗ trợ đăng nhập nhanh qua tài khoản GitHub hoặc Google, đảm bảo an toàn cho tài khoản của bạn đồng thời đơn giản hóa quy trình đăng ký."
            },
            {
                id : 7,
                question: "Tốc độ xử lý nhanh như thế nào?",
                answer: "Nhờ máy chủ hiệu suất cao và thuật toán AI được tối ưu hóa, hầu hết các tác vụ xóa hình mờ trong ảnh có thể hoàn thành trong vòng 10 giây, trong khi xóa hình mờ video có thể mất chỉ 1 phút trong trường hợp nhanh nhất. Thời gian thực tế có thể khác nhau tùy thuộc vào kích thước và độ phức tạp của tệp."
            },
            {
                id : 8,
                question: "Hiệu quả sau khi xử lý như thế nào?",
                answer: "Mô hình AI của chúng tôi được đào tạo rộng rãi, có thể thông minh loại bỏ hình mờ khỏi hình ảnh và video trong khi vẫn duy trì chất lượng của nội dung gốc. Dù là hình mờ được nhận diện tự động hay đánh dấu thủ công, chúng đều được loại bỏ hiệu quả, đảm bảo kết quả cuối cùng tự nhiên và không có dấu vết."
            },
            {
                id : 9,
                question: "Thời hạn của mỗi tác vụ là bao lâu?",
                answer: "Khi tác vụ hoàn thành, tệp đã xử lý sẽ được lưu trữ trên ClixMagicAI trong 24 giờ để người dùng tải xuống. Sau khi hết hạn, tệp sẽ tự động bị xóa khỏi máy chủ của chúng tôi để bảo vệ quyền riêng tư của bạn."
            },
            {
                id : 10,
                question: "Giới hạn kích thước tệp tối đa là bao nhiêu?",
                answer: "Chúng tôi chấp nhận kích thước tệp hình ảnh tối đa là 10MB và tệp video tối đa là 100MB. Tệp vượt quá giới hạn này có thể cần phải nén hoặc cắt bớt trước khi tải lên."
            }
        ]
    },
    Terms: {
        "tabs": {
            "terms": "Điều khoản dịch vụ",
            "privacy": "Chính sách quyền riêng tư",
            "cookies": "Chính sách cookie"
        },
        "lastUpdated": "Cập nhật lần cuối: Ngày 20 tháng 5 năm 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Giới thiệu",
                    "description": "Chào mừng đến với ClixMagicAI. Việc sử dụng dịch vụ của chúng tôi đồng nghĩa với việc bạn đồng ý với các Điều khoản Dịch vụ này. Vui lòng đọc kỹ."
                },
                {
                    "title": "2. Mô tả dịch vụ",
                    "description": "ClixMagicAI cung cấp các công cụ được hỗ trợ bởi AI để xóa hình mờ khỏi hình ảnh, video và PDF. Dịch vụ của chúng tôi phù hợp cho các mục đích hợp pháp sau:",
                    "items": [
                        "Xóa hình mờ khỏi nội dung của bạn",
                        "Xóa hình mờ khỏi nội dung mà bạn có quyền chỉnh sửa thích hợp",
                        "Cho mục đích giáo dục và nghiên cứu"
                    ]
                },
                {
                    "title": "3. Trách nhiệm của người dùng",
                    "description": "Khi sử dụng ClixMagicAI, bạn đồng ý rằng:",
                    "items": [
                        "Chỉ tải lên nội dung thuộc sở hữu của bạn hoặc nội dung mà bạn có quyền chỉnh sửa thích hợp",
                        "Không sử dụng dịch vụ của chúng tôi cho bất kỳ mục đích bất hợp pháp nào hoặc vi phạm bất kỳ luật nào",
                        "Không cố gắng phá vỡ các biện pháp bảo mật hoặc hạn chế sử dụng của chúng tôi",
                        "Không sử dụng dịch vụ của chúng tôi để vi phạm quyền sở hữu trí tuệ của người khác"
                    ]
                },
                {
                    "title": "4. Điều khoản tài khoản",
                    "description": "Bạn có thể cần tạo một tài khoản để sử dụng một số tính năng của dịch vụ chúng tôi. Để đăng nhập, bạn có thể sử dụng tài khoản Google hoặc GitHub. Bạn chịu trách nhiệm về:",
                    "items": [
                        "Duy trì bảo mật tài khoản của bạn",
                        "Tất cả các hoạt động diễn ra dưới tài khoản của bạn",
                        "Cung cấp thông tin tài khoản chính xác (bao gồm avatar, email, tên người dùng và ID người dùng)"
                    ]
                },
                {
                    "title": "5. Dịch vụ miễn phí và trả phí",
                    "description": "ClixMagicAI cung cấp hạn mức cơ bản miễn phí và các tùy chọn mua điểm linh hoạt để truy cập vào các tính năng xóa hình mờ của chúng tôi:",
                    "items": [
                        "Hạn mức cơ bản: Mỗi người dùng sẽ tự động nhận được 3 điểm miễn phí mỗi ngày, có thể sử dụng để xử lý nội dung",
                        "Quy tắc tiêu thụ điểm: Xóa hình mờ ảnh tiêu thụ 1 điểm mỗi lần, xóa hình mờ video tiêu thụ 3 điểm mỗi lần",
                        "Mua điểm: Bạn có thể mua các gói điểm để sử dụng thêm, tất cả điểm đã mua có hiệu lực vĩnh viễn, không có giới hạn hết hạn",
                        "Chính sách hoàn tiền: Do tính chất tức thời và ảo của dịch vụ kỹ thuật số, các điểm đã mua thành công không được hoàn lại"
                    ]
                },
                {
                    "title": "6. Quyền sở hữu trí tuệ",
                    "description": "Dịch vụ ClixMagicAI, bao gồm tất cả phần mềm, thiết kế và nội dung do chúng tôi tạo ra, là tài sản trí tuệ của chúng tôi. Nếu không có sự cho phép, bạn không được sao chép, sửa đổi hoặc tạo các tác phẩm phái sinh dựa trên dịch vụ của chúng tôi."
                },
                {
                    "title": "7. Giới hạn trách nhiệm",
                    "description": "ClixMagicAI cung cấp dịch vụ \"nguyên trạng\", không có bảo đảm dưới bất kỳ hình thức nào. Chúng tôi không chịu trách nhiệm về bất kỳ thiệt hại nào phát sinh từ việc sử dụng dịch vụ của chúng tôi."
                },
                {
                    "title": "8. Thay đổi điều khoản",
                    "description": "Chúng tôi có thể sửa đổi các điều khoản này bất cứ lúc nào. Việc tiếp tục sử dụng ClixMagicAI sau khi thay đổi điều khoản cấu thành sự chấp nhận các điều khoản đã sửa đổi của bạn."
                },
                {
                    "title": "9. Chấm dứt",
                    "description": "Chúng tôi bảo lưu quyền chấm dứt hoặc đình chỉ quyền truy cập của bạn vào dịch vụ của chúng tôi ngay lập tức, mà không cần thông báo trước, nếu chúng tôi tin rằng hành vi của bạn vi phạm các điều khoản này hoặc gây hại cho người dùng khác, cho chúng tôi hoặc cho bên thứ ba."
                },
                {
                    "title": "10. Luật áp dụng",
                    "description": "Các điều khoản này sẽ được điều chỉnh bởi luật pháp áp dụng tại nơi đăng ký của công ty chúng tôi, không xem xét đến các quy định xung đột pháp luật."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Giới thiệu",
                    "description": "Tại ClixMagicAI, chúng tôi coi trọng quyền riêng tư của bạn và cam kết bảo vệ dữ liệu cá nhân của bạn. Chính sách Quyền riêng tư này giải thích cách chúng tôi thu thập, sử dụng và bảo vệ thông tin của bạn khi bạn sử dụng trang web và dịch vụ của chúng tôi. Khi truy cập trang web của chúng tôi hoặc sử dụng bất kỳ dịch vụ nào, bạn đồng ý với các phương thức xử lý dữ liệu được mô tả trong chính sách này. Chúng tôi tuân thủ các quy định bảo vệ dữ liệu hiện hành."
                },
                {
                    "title": "2. Thông tin chúng tôi thu thập",
                    "description": "Chúng tôi có thể thu thập các loại thông tin sau:",
                    "items": [
                        { "bold": "Thông tin tài khoản", "text": "Ảnh đại diện, địa chỉ email, tên người dùng và ID người dùng được cung cấp khi đăng nhập thông qua Google hoặc GitHub" },
                        { "bold": "Dữ liệu sử dụng", "text": "Thông tin về cách bạn sử dụng dịch vụ của chúng tôi, bao gồm các tính năng được truy cập và thời gian sử dụng" },
                        { "bold": "Nội dung tải lên", "text": "Hình ảnh, video hoặc PDF bạn tải lên để xử lý" },
                        { "bold": "Thông tin thanh toán", "text": "Thông tin thanh toán khi mua đăng ký (được xử lý an toàn bởi các cổng thanh toán của bên thứ ba như Creem/Stripe/PayPal, chúng tôi chỉ lưu giữ bản ghi trạng thái thanh toán)" },
                        { "bold": "Dữ liệu kỹ thuật", "text": "Địa chỉ IP, loại trình duyệt, thông tin thiết bị" }
                    ]
                },
                {
                    "title": "3. Cách chúng tôi sử dụng thông tin của bạn",
                    "description": "Chúng tôi sử dụng thông tin của bạn để:",
                    "items": [
                        { "text": "Cung cấp, duy trì và cải thiện dịch vụ của chúng tôi" },
                        { "text": "Xử lý và hoàn tất giao dịch" },
                        { "text": "Gửi thông báo kỹ thuật và tin nhắn hỗ trợ" },
                        { "text": "Phản hồi ý kiến và câu hỏi của bạn" },
                        { "text": "Phân tích mô hình sử dụng để cải thiện trải nghiệm người dùng, và chỉ xử lý dữ liệu cá nhân trong phạm vi cần thiết cho mục đích dịch vụ" },
                        { "text": "Đảm bảo thời gian lưu trữ dữ liệu cá nhân không vượt quá thời gian cần thiết" },
                        { "text": "Ngăn chặn gian lận hoặc hoạt động bất hợp pháp" }
                    ]
                },
                {
                    "title": "4. Bảo mật dữ liệu",
                    "description": "Chúng tôi áp dụng các biện pháp bảo mật theo tiêu chuẩn ngành để bảo vệ thông tin cá nhân của bạn:",
                    "items": [
                        { "text": "Mã hóa tệp bằng AES-256 trong quá trình truyền và lưu trữ" },
                        { "text": "Dữ liệu nhạy cảm được xử lý bằng kiến trúc zero-knowledge" },
                        { "text": "Kiểm tra nhật ký bảo mật hàng ngày và quét lỗ hổng" },
                        { "text": "Quyền truy cập của nhân viên tuân theo nguyên tắc đặc quyền tối thiểu" }
                    ]
                },
                {
                    "title": "5. Chia sẻ dữ liệu",
                    "description": "Chúng tôi không bán thông tin cá nhân của bạn. Chúng tôi có thể chia sẻ thông tin với các bên sau:",
                    "items": [
                        { "bold": "Nhà cung cấp dịch vụ", "text": "Giới hạn ở việc xử lý dữ liệu cần thiết chỉ để cung cấp dịch vụ cụ thể (như lưu trữ đám mây CloundFlare, cổng thanh toán của bên thứ ba như Creem/Stripe/PayPal), và tuân theo các thỏa thuận xử lý dữ liệu" },
                        { "bold": "Yêu cầu pháp lý", "text": "Khi chúng tôi nhận được lệnh triệu tập, lệnh tòa án hoặc thủ tục pháp lý hiện hành khác" }
                    ]
                },
                {
                    "title": "6. Quyền của bạn",
                    "description": "Theo luật hiện hành ở khu vực của bạn, bạn có thể có các quyền sau:",
                    "items": [
                        { "text": "Truy cập bản sao dữ liệu cá nhân của bạn" },
                        { "text": "Sửa thông tin không chính xác hoặc không đầy đủ" },
                        { "text": "Quyền xóa dữ liệu ('quyền được quên lãng'), trừ khi chúng tôi có lý do hợp pháp để giữ lại" },
                        { "text": "Phản đối hoặc hạn chế một số loại xử lý dữ liệu" },
                        { "text": "Quyền di chuyển dữ liệu, cho phép bạn yêu cầu chuyển dữ liệu của mình" }
                    ]
                },
                {
                    "title": "7. Quyền riêng tư của trẻ em",
                    "description": "Dịch vụ của chúng tôi không dành cho trẻ em dưới 16 tuổi. Theo Điều 8 của Quy định Bảo vệ Dữ liệu Chung (GDPR), sự đồng ý đối với trẻ em dưới 16 tuổi phải được đưa ra bởi cha mẹ hoặc người giám hộ của họ. Nếu bạn biết rằng một đứa trẻ dưới 16 tuổi đã cung cấp cho chúng tôi thông tin cá nhân, vui lòng liên hệ với chúng tôi ngay lập tức tại support@clixmagic.com."
                },
                {
                    "title": "8. Thay đổi chính sách này",
                    "description": "Chúng tôi có thể cập nhật Chính sách Quyền riêng tư này định kỳ để phản ánh những thay đổi trong công nghệ, quy định hoặc thực tiễn kinh doanh của chúng tôi. Mọi thay đổi sẽ được đăng trên trang này và cập nhật ngày \"cập nhật lần cuối\"."
                },
                {
                    "title": "9. Liên hệ với chúng tôi",
                    "description": "Nếu bạn có bất kỳ câu hỏi nào về Chính sách Quyền riêng tư này, vui lòng liên hệ với chúng tôi tại support@clixmagic.com. Nếu bạn tin rằng dữ liệu của bạn đã được xử lý không đúng cách hoặc có bất kỳ mối quan tâm nào khác, đừng ngần ngại liên hệ với chúng tôi bất cứ lúc nào."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Cookie là gì",
                    "description": "Cookie là các tệp văn bản nhỏ được đặt trên máy tính hoặc thiết bị di động của bạn khi bạn truy cập các trang web. Chúng cho phép trang web nhận dạng thiết bị của bạn và nhớ liệu bạn đã truy cập trang web trước đó hay chưa."
                },
                {
                    "title": "2. Cách chúng tôi sử dụng cookie",
                    "description": "ClixMagicAI sử dụng cookie cho nhiều mục đích:",
                    "items": [
                        { "bold": "Cookie thiết yếu", "text": "Cần thiết cho chức năng cơ bản của trang web của chúng tôi (như quản lý phiên và tính năng bảo mật)" },
                        { "bold": "Cookie tùy chọn", "text": "Ghi nhớ cài đặt và tùy chọn của bạn để cải thiện trải nghiệm của bạn, chẳng hạn như ghi nhớ avatar, tên người dùng, v.v. sau khi đăng nhập thông qua Google hoặc GitHub" },
                        { "bold": "Cookie phân tích", "text": "Giúp chúng tôi hiểu cách người truy cập tương tác với trang web của chúng tôi bằng cách thu thập thông tin ẩn danh" },
                        { "bold": "Cookie tiếp thị", "text": "Cung cấp quảng cáo phù hợp với sở thích của bạn bằng cách theo dõi thói quen duyệt web của bạn" }
                    ]
                },
                {
                    "title": "3. Loại cookie chúng tôi sử dụng",
                    "subsection": [
                        {
                            "title": "3.1 Cookie thiết yếu",
                            "description": "Những cookie này cần thiết cho hoạt động thích hợp của trang web. Chúng cho phép các chức năng cốt lõi như bảo mật, quản lý mạng và truy cập tài khoản (bao gồm đăng nhập Google và GitHub). Bạn có thể cài đặt trình duyệt của mình để chặn các cookie này, nhưng một số phần của trang web có thể không hoạt động chính xác."
                        },
                        {
                            "title": "3.2 Cookie hiệu suất và phân tích",
                            "description": "Những cookie này thu thập thông tin ẩn danh giúp chúng tôi hiểu cách người truy cập tương tác với trang web của chúng tôi. Chúng tôi sử dụng dữ liệu này để cải thiện trang web và dịch vụ của chúng tôi. Những cookie này không thu thập thông tin có thể xác định người truy cập."
                        },
                        {
                            "title": "3.3 Cookie chức năng",
                            "description": "Những cookie này cho phép trang web của chúng tôi nhớ các lựa chọn bạn đã thực hiện (như tùy chọn ngôn ngữ hoặc trạng thái đăng nhập) để cung cấp các tính năng cá nhân hóa nâng cao, như ghi nhớ trạng thái đăng nhập của bạn thông qua Google hoặc GitHub."
                        },
                        {
                            "title": "3.4 Cookie nhắm mục tiêu và quảng cáo",
                            "description": "Những cookie này được sử dụng để hiển thị quảng cáo phù hợp với người truy cập và theo dõi hiệu quả của các chiến dịch quảng cáo của chúng tôi. Lưu ý rằng, vì trang web của chúng tôi chủ yếu dựa vào đăng nhập của bên thứ ba (Google và GitHub), loại cookie này chủ yếu được sử dụng để cải thiện trải nghiệm người dùng chứ không phải cho tiếp thị trực tiếp."
                        }
                    ]
                },
                {
                    "title": "4. Quản lý cookie",
                    "description": "Bạn có thể kiểm soát và quản lý cookie theo nhiều cách. Hầu hết các trình duyệt web cho phép bạn quản lý tùy chọn cookie của mình. Bạn có thể:",
                    "items": [
                        { "text": "Xóa cookie khỏi thiết bị của bạn" },
                        { "text": "Chặn cookie bằng cách kích hoạt cài đặt trong trình duyệt của bạn cho phép bạn từ chối tất cả hoặc một số cookie" },
                        { "text": "Cài đặt trình duyệt của bạn để thông báo cho bạn khi bạn nhận được cookie" }
                    ]
                },
                {
                    "title": "5. Cookie của bên thứ ba",
                    "description": "Một số cookie được đặt bởi bên thứ ba trên trang web của chúng tôi. Những bên thứ ba này có thể bao gồm dịch vụ phân tích (như Google Analytics) và mạng quảng cáo. Do cách thức hoạt động của cookie (cookie chỉ có thể được truy cập bởi bên đã thiết lập chúng ban đầu), chúng tôi không kiểm soát việc sử dụng các cookie của bên thứ ba này hoặc không thể truy cập vào chúng. Đối với người dùng đăng nhập thông qua Google và GitHub, chúng tôi sẽ đảm bảo tuân theo hướng dẫn về quyền riêng tư của các nền tảng này khi xử lý thông tin liên quan."
                },
                {
                    "title": "6. Cập nhật chính sách cookie này",
                    "description": "Chúng tôi có thể cập nhật chính sách cookie này theo thời gian để phản ánh những thay đổi trong công nghệ, quy định hoặc thực tiễn kinh doanh của chúng tôi. Mọi thay đổi sẽ được đăng trên trang này và ngày sửa đổi sẽ được cập nhật."
                },
                {
                    "title": "7. Liên hệ với chúng tôi",
                    "description": "Nếu bạn có bất kỳ câu hỏi nào về việc sử dụng cookie của chúng tôi, vui lòng liên hệ với chúng tôi tại support@clixmagic.com."
                }
            ]
        }
    },
}